import React from "react";
import ContactSection from "../../components/contact/ContactSection";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Title from "../../components/about/common/Title";
const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    marginBottom: "5rem",
  },
}));
const Contact = () => {
  const classes = useStyles();

  return (
    <div>
      <Container className={classes.root}>
        <Title
          title="Contact Us"
          description="Do you want to volunteer, do an internship or ask something? You canfill out the form so that we can contact you as soon as possible."
        />
        <ContactSection />
      </Container>
    </div>
  );
};

export default Contact;
